import { Resources } from 'constants/resources';

import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MethodsDeleteDialog } from 'pages/Methods/components/MethodsDeleteDialog/MethodsDeleteDialog';
import { useShowController } from 'react-admin';
import { DeleteButton, EditLinkButton } from 'shared/mui/Buttons';
import { ContextMenu, ContextMenuEntityUserActionsButton } from 'shared/mui/ContextMenu';
import { ShowPage } from 'shared/react-admin/Pages/ShowPage/ShowPage';
import { MethodsShowChipFields } from 'shared/widgets/MethodsShow/MethodsShowChipFields';
import { MethodsShowSkeleton } from 'shared/widgets/MethodsShow/MethodsShowSkeleton';
import { MethodsShowTable } from 'shared/widgets/MethodsShow/MethodsShowTable';
import { Method } from 'types/embedded/method';
import { Permission } from 'types/embedded/permission';

export const MethodsShow: React.FC = () => {
  const { hasResourcePermissions, hasResourceAccess } = usePermissions();
  const { record } = useShowController<Method>();

  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<Method>();

  return (
    <ShowPage
      actions={
        hasResourceAccess(Resources.UserActions) && (
          <ContextMenu key="context-menu-button">
            <ContextMenuEntityUserActionsButton entityName="method" />
          </ContextMenu>
        )
      }
      listName="Методы"
      rightActionsSlot={[
        hasResourcePermissions(Resources.Methods, [Permission.Full, Permission.Delete]) && (
          <DeleteButton
            key="delete-button"
            onClick={() => handleOpenRecordModal()}
            variant="outlined"
          />
        ),
        hasResourcePermissions(Resources.Methods, [Permission.Full, Permission.Update]) && (
          <EditLinkButton key="edit-button" label="Редактировать" variant="contained" />
        ),
      ]}
      skeleton={<MethodsShowSkeleton />}
      title="Просмотр метода"
    >
      <MethodsShowChipFields />
      <MethodsShowTable />
      {openRecordModal && (
        <MethodsDeleteDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        />
      )}
    </ShowPage>
  );
};
